module.exports = __webpack_public_path__ + "static/media/boy.d614d2e5.png";